import Icon from './Icon';

export default Icon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/cf-component-icon/es/index.js
// module id = 300
// module chunks = 0